// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs_breadcrumbs__zaKZI","crumb":"breadcrumbs_crumb__BvQqo"};